<template>
  <div class="password-reset">
    <h1 v-if="title">{{ title }}</h1>

    <div v-if="!statusMessage" class="form-group password-group">
      <input
        v-model="password"
        :type="showPassword ? 'text' : 'password'"
        placeholder="Password"
        :class="pwErrClass"
      />
      <font-awesome-icon
        class="password-toggle-icon"
        :icon="showPassword ? 'eye-slash' : 'eye'"
        @click="showPassword = !showPassword"
      />
    </div>
    <div v-if="!statusMessage" class="form-group password-group">
      <input
        v-model="confirmPassword"
        :type="showConfirmPassword ? 'text' : 'password'"
        placeholder="Confirm password"
        :class="errClass"
      />
      <font-awesome-icon
        class="password-toggle-icon"
        :icon="showConfirmPassword ? 'eye-slash' : 'eye'"
        @click="showConfirmPassword = !showConfirmPassword"
      />
    </div>
    <div v-if="msg && !statusMeessage" class="form-group">
      {{ msg }}
    </div>
    <div v-if="statusMessage" class="form-group">
      {{ statusMessage }}
    </div>

    <div v-if="!statusMessage" class="btn-holder reset">
      <button @click.prevent="handleSubmit()">Submit</button>
    </div>
    <div v-if="statusMessage" class="btn-holder reset">
      <button @click.prevent="handleOkay()">Okay</button>
    </div>

    <div v-if="!statusMessage" class="form-group">
      <ul>
        <li v-for="(h, idx) of helperMsg" :key="idx">{{ h }}</li>
      </ul>
    </div>
  </div>
</template>

<script>
import { userUtils } from '@/mixins/user-utils';
export default {
  mixins: [userUtils],
  props: {
    title: {
      type: String,
      default: ''
    },
    statusMessage: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      password: '',
      confirmPassword: '',
      showPassword: false,
      showConfirmPassword: false,
      helperMsg: [
        'Passwords must be at least 8 characters long',
        'Passwords must have at least 1 uppercase letter [A-Z]',
        'Passwords must have at least 1 lowercase letter [a-z]',
        'Passwords must have at least 1 digit [0-9]',
        'Passwords must have at least one special character [~!@#$%^&*]'
      ],
      msg: null,
      errClass: '',
      pwErrClass: ''
    };
  },
  watch: {
    password: {
      handler(val) {
        this.pwErrClass = val && this.isValidPassword(val) ? 'green' : 'red';
      }
    },
    confirmPassword: {
      handler(val) {
        this.errClass = this.password && val !== this.password ? 'red' : 'green';
      }
    }
  },
  methods: {
    handleSubmit() {
      if (this.password && this.confirmPassword && this.password === this.confirmPassword) {
        if (this.isValidPassword(this.password)) {
          this.$emit('save', {
            password: this.password,
            confirmPassword: this.confirmPassword
          });
        } else {
          this.msg = "Your password does not satisfy our 'strong password' standard";
        }
      } else {
        this.msg = 'Your passwords do not match';
      }
    },
    handleOkay() {
      this.$router.push('/login');
    }
  }
};
</script>

<style scoped lang="scss">
@import '@/app/styles/colors.scss';
@import '@/app/styles/variables.scss';

.password-reset {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  min-height: 350px;
  display: flex;
  flex-basis: 640px;
  flex-direction: column;
  padding: 30px;
  &:hover {
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
  }
  .form-group {
    margin-bottom: 12px;
    label {
      display: block;
    }
    input {
      width: 100%;
      height: 35px;
      text-align: center;
      &:focus {
        outline: none;
      }
      &.red {
        border: 0;
        border: 1px solid $red;
      }
      &.green {
        border: 0;
        border: 1px solid $green;
      }
    }
    &.password-group {
      position: relative;
      input {
        padding-right: 35px;
      }
      .password-toggle-icon {
        position: absolute;
        right: 12px;
        top: 50%;
        transform: translateY(-50%);
        cursor: pointer;
        color: $text-color-dark;
      }
    }
    &.msg {
      margin-top: 12px;
    }

    ul {
      list-style: none;
      padding: 0;
      margin: 0;
      li {
        padding: 12px;
        &:not(:last-of-type) {
          margin-bottom: 1px dotted $row-border;
        }
      }
    }
  }
  .btn-holder {
    margin-top: auto;
    justify-self: flex-end;
    &.reset {
      margin-left: auto;
    }
  }

  button {
    //background-color: $green;
    padding: 10px;
    width: 150px;
  }
}
</style>
